import React from "react";
import { Outlet } from "react-router-dom";

const MediaManagement: React.FC = () => {
    return <Outlet />;
};

export default MediaManagement;
